<div class="flex md:items-center md:justify-center min-h-screen">
  <!-- Contenedor principal: full width en mobile, tarjeta centrada en tablet/escritorio -->
  <div class="w-full p-3 md:max-w-md md:bg-white md:rounded-xl md:shadow-lg md:p-8">
    <!-- Logo / Title -->
    <div class="text-center">
      <h2 class="mt-2 text-xl font-subtitle text-metro-blue-secondary">{{'::ForgotPassword' | abpLocalization}}</h2>
    </div>

    <!-- Success Message -->
    @if (isEmailSent) {
      <div class="mt-8">
        <div class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative" role="alert">
          <strong class="font-bold">{{'::SuccessfullySent' | abpLocalization}} </strong>
          <span class="block sm:inline">{{"::PasswordResetMessage" | abpLocalization}}</span>
        </div>
        <div class="mt-6 text-center">
          <div class="mt-6 text-center text-sm text-metro-blue-secondary">
            <a routerLink="/account/login" class="hover:underline">{{'::BackToLogin' | abpLocalization}}</a>
          </div>
        </div>
      </div>
    } @else {
      <!-- Form -->
      <form class="mt-8 space-y-4" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        
        <!-- Email -->
        <app-metro-form-input
          formControlName="email"
          [placeholder]="'Email'"
          size="md"
          type="text">
        </app-metro-form-input>

        <!-- Submit Button -->
        <app-metro-button
          class="w-full"
          variant="primary"
          [customClass]="'bg-metro-blue-secondary text-metro-black w-full'"
          [text]="(inProgress ? '::Sending' : '::Send') | abpLocalization"
          type="submit"
          [disabled]="forgotPasswordForm.invalid || inProgress">
        </app-metro-button>
      </form>

      <!-- Back to Login -->
      <div class="mt-6 text-center text-sm text-metro-blue-secondary">
        <a routerLink="/account/login" class="hover:underline">{{'::BackToLogin' | abpLocalization}}</a>
      </div>
    }
  </div>
</div>